module.exports = __webpack_public_path__ + "static/media/carousel_item_3-large.61221f48.png";